var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyzeSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    className: "sharpcorners_een",
    d: "M16,27H4v-2h12V27z M12,0H8v3h4V0z M8,11v11h4V11H8z M29,18.5C29,11.056,22.944,5,15.5,5H13V4H7v6 h6V9h2.5c5.238,0,9.5,4.262,9.5,9.5S20.738,28,15.5,28H3v4h26v-4h-3.921C27.5,25.559,29,22.202,29,18.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeSvg);
export default __webpack_public_path__ + "static/media/analyze-svg.c6fae5f3afc6aa03e1e590a13d0585fa.svg";
export { ForwardRef as ReactComponent };